'use client';

import { Section } from '.';
import { SectionProps } from './SectionRules';

export function ClientSection(props: SectionProps) {
  return <Section {...props} />;
}
